<template>
    <div>
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/ClothManage' }">服饰管理</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="10" style="display:flex;align-items:center">
                        <el-col :span="1.5">
                            <div class="grid-content bg-purple">
                                <span style="font-size:14px">款号:</span>
                            </div>
                        </el-col>
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInfo.clothesName"  placeholder="请输入款号" clearable></el-input></div
                        ></el-col>
                        <el-col :span="1.5" style="margin-left:10px">
                            <div class="grid-content bg-purple">
                                <span style="font-size:14px">专区:</span>
                            </div>
                        </el-col>
                        <el-col :span="3">
                             <el-select v-model="searchInfo.clothesSeason" placeholder="请选择服饰专区" @change="selectSeason">
                                    <el-option
                                    v-for="item in seasonList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                        </el-col>
                        <el-col :span="3">
                             <el-select v-model="searchInfo.clothesSubZone" placeholder="请选择子专区">
                                    <el-option
                                    v-for="item in clothesZone"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                        </el-col>
                        <el-col :span="10">
                            <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                             <el-button style="background-color: #ffb135;color: #fff" icon="el-icon-refresh-left" @click="reset()">重置</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="$refs.add.openDialog()">新增</el-button>
                        </el-col>
                    </el-row>
                     <el-table :data="tableData" style="width: 100%;margin-bottom:20px" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="100" align="center">
                            <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column prop="clothesName" label="吊牌款号" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="clothesFactory" label="品牌商" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="clothesType" label="服饰类别" :resizable="false" width="100" align="center"></el-table-column>
                        <el-table-column prop="clothesMaterial" label="服装材质" :resizable="false" align="center"></el-table-column>
                        <!-- <el-table-column prop="clothesPurchasePrice" label="进价" :resizable="false" width="150" align="center"></el-table-column> -->
                        <el-table-column prop="clothesWholesalePrice" label="批发价" :resizable="false" width="150" align="center"></el-table-column>
                        <el-table-column prop="clothesRetailPrice" label="零售价" :resizable="false" width="150" align="center"></el-table-column>
                        <el-table-column prop="clothesSeason" label="专区" :resizable="false" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ seasonList[scope.row.clothesSeason - 1].label }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="clothesSeason" label="子专区" :resizable="false" width="100" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.clothesSubZone">{{seasonList[scope.row.clothesSeason - 1].children[scope.row.clothesSubZone - 1].label}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="edit(scope.row.id)">修改</el-button>
                                <el-button type="text" size="small" @click="deleteClothes(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <add ref="add" @getClothesList="getClothesList"
         v-bind:clothesDictionary="clothesDictionary" v-if="isGetDictionaryData" 
        ></add>
        <edit ref="edit" @getClothesList="getClothesList"
        v-bind:clothesDictionary="clothesDictionary" v-if="isGetDictionaryData" 
        ></edit>
    </div>
</template>
<script>
import add from './ClothManageChildren/add.vue';
import edit from './ClothManageChildren/edit.vue';
export default {
    data() {
        return {
            searchInput: '',
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                //款号
                clothesName: '',
                clothesSeason: '',
                clothesSubZone: ''
            },
            // 数据列表
            tableData: [],
            clothesZone: [],
            isGetDictionaryData: false,
            // 数据总数
            total: 0,
            dialogVisible: false,
            seasonList: [
                {
                    value: 1,
                    label: '春秋专区',
                    children: [
                        {value: 1,label: '春秋套装'},
                        {value: 2,label: '针织卫衣'},
                        {value: 3,label: '春秋裤类'},
                        {value: 4,label: '户外风衣'},
                        {value: 5,label: '抓绒衣'}
                    ]
                },
                {
                    value: 2,
                    label: '夏季专区',
                    children: [
                        {value: 1,label: '夏季套装'},
                        {value: 2,label: '圆领短袖'},
                        {value: 3,label: '夏季裤类'},
                        {value: 4,label: '防晒服'},
                        {value: 5,label: '短裤专区'},
                        {value: 6,label: '翻领短袖'},
                    ]
                },
                {
                    value: 3,
                    label: '冬季专区',
                    children: [
                        {value: 1,label: '冬季套装'},
                        {value: 2,label: '冲锋衣'},
                        {value: 3,label: '加绒卫衣'},
                        {value: 4,label: '冬季裤类'},
                        {value: 5,label: '加绒风衣'},
                        {value: 6,label: '羽绒棉衣'}
                    ]
                },
                {
                    value: 4,
                    label: '比赛运动区',
                    children: [
                        {value: 1,label: '篮球服'},
                        {value: 2,label: '足球服'},
                        {value: 3,label: '排球服'},
                        {value: 4,label: '田径服'},
                        {value: 5,label: '乒羽服'},
                        {value: 6,label: '运动健身区'},
                        {value: 7,label: '裤裙区'},
                        {value: 8,label: '短袖PoLo衫'},
                        {value: 9,label: '体育用品'}
                    ]
                },
                {
                    value: 5,
                    label: '团购专区',
                    children: [
                        {value: 1,label: '春秋团购'},
                        {value: 2,label: '夏季团购'},
                        {value: 3,label: '冬季团购'},
                        {value: 4,label: '出场服'},
                        {value: 5,label: '雪袍大衣'}
                    ]
                },
                {
                    value: 6,
                    label: '特价区',
                    children: [
                        {value: 1,label: '春秋特价'},
                        {value: 2,label: '夏季特价'},
                        {value: 3,label: '冬季特价'}
                    ]
                }
            ],
            
            clothesDictionary: []
        };
    },
    components: { add, edit },
    created() {
        // 获取数据列表
        this.getClothesList();
        this.getClothesDictionary();
    },
    methods: {
        selectSeason(value){
            this.clothesZone = this.seasonList[value - 1].children
            this.searchInfo.clothesSubZone = ''
        },
        search() {
            this.searchInfo.pageNum = 1;
            this.getClothesList();
        },
        reset() {
            this.searchInfo = {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                //款号
                clothesName: '',
                clothesSeason: '',
                clothesSubZone: ''
            }
            this.search();
        },
        async getClothesList() {
            const res = await this.$axios.post('manage/cloth/search', this.searchInfo);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        async getClothesDictionary() {
            const res = await this.$axios.post('manage/cloth/searchClothesDictionaryList');
            if (res.data.code == 0) {
                this.clothesDictionary = res.data.data;
                this.isGetDictionaryData = true;
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        async deleteClothes(id) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .get('manage/cloth/deleteClothes', {
                        params : {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getClothesList();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch(() => {
                        this.getClothesList();
                    });
            });
        },
        edit(data) {
            this.$refs.edit.getClothesInfo(data)
        },
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getClothesList();
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getClothesList();
        },

        handleToSearch() {
            this.searchInfo.pageNum = 1;
            this.getClothesList();
        },
        handleClosePwd() {
                    this.dialogVisible = false;
                }
    }
}
</script>
<style>
.el-table {
    margin-top: 20px;
}

</style>